<template>
  <div class="custom-container">
    <Selection v-show="isStep1" :OnCarSelected="OnCarSelected" />
    <Selfie :Player="nowPlayer" v-show="isStep2" :OnSelfieUploded="OnSelfieUploded" />
    <Ready ref="Ready" :Player="nowPlayer" v-show="isStep3" :OnCountdownEnded="OnCountdownEnded" />
    <Running ref="Running" :Player="nowPlayer" v-show="isRunning" />
    <Level1 :Player="nowPlayer" v-if="isLevel1" :OnLevel1Finished="OnLevel1Finished" />
    <Level2 :Player="nowPlayer" v-if="isLevel2" :OnLevel2Finished="OnLevel2Finished" />
    <Finish
      ref="Finish"
      :Player="nowPlayer"
      v-show="isFinish"
      :OnCountdownEnded="OnFinishCountDownEnded"
    />
  </div>
</template>
<script>
import DataServices from "../services/DataService";
import Selection from "./Selection";
import Selfie from "./Selfie";
import Ready from "./Ready";
import Running from "./Running";
import Level1 from "./Level1";
import Level2 from "./Level2";
import Finish from "./Finish";
export default {
  components: {
    Selection,
    Selfie,
    Ready,
    Running,
    Level1,
    Level2,
    Finish
  },
  data() {
    return {
      isStep1: false,
      isStep2: false,
      isStep3: false,
      isRunning: false,
      isLevel1: false,
      isLevel2: false,
      isFinish: false,
      preTime: 0,
      x: 0,
      y: 0,
      z: 0,
      preX: 0,
      preY: 0,
      preZ: 0,
      isMotionAdded: false,
      nowPlayer: {}
    };
  },
  async mounted() {
    this.GetPermission();
    this.$mqtt.subscribe(`heysong/${process.env.VUE_APP_MODE}/#`);
    var token = "empty";
    if (this.$cookies.isKey("token")) {
      token = this.$cookies.get("token");
    }
    var result = await DataServices.Login({
      token: token
    });
    if (result.success) {
      this.$cookies.set("token", result.token);
      this.nowPlayer = result.player;
      this.SetLevel(result.player.status);
    } else {
      alert("登入失敗，請稍後重新整理頁面");
    }
  },
  mqtt: {
    "heysong/+/level": function(val) {
      var data = JSON.parse(val);
      if (data.id == this.nowPlayer.id) {
        if (data.score) {
          this.nowPlayer.score = data.score;
        }
        if (data.cardUrl) {
          this.nowPlayer.cardUrl = data.cardUrl;
        }
        this.SetLevel(data.status);
      }
    }
  },
  methods: {
    SetLevel(data) {
      switch (data) {
        case "init":
          this.isStep1 = true;
          this.isStep2 = false;
          this.isStep3 = false;
          this.isRunning = false;
          this.isLevel1 = false;
          this.isLevel2 = false;
          this.isFinish = false;
          break;
        case "level1":
          this.isFinish = false;
          this.isLevel2 = false;
          this.isRunning = false;
          this.isLevel1 = true;
          break;
        case "level2":
          this.isFinish = false;
          this.isLevel1 = false;
          this.isRunning = false;
          this.isLevel2 = true;
          break;
        case "running":
          this.isStep1 = false;
          this.isStep2 = false;
          this.isStep3 = false;
          this.isFinish = false;
          this.isLevel1 = false;
          this.isLevel2 = false;
          this.$refs.Running.OnSetCarIndex(this.nowPlayer);
          this.isRunning = true;
          break;
        case "finish":
          this.isLevel1 = false;
          this.isLevel2 = false;
          this.isRunning = false;
          this.$refs.Finish.Countdown(
            this.nowPlayer.score,
            this.nowPlayer.cardUrl
          );
          this.isFinish = true;
          break;
        default:
          break;
      }
    },
    async OnLevel2Finished(score) {
      var result = await DataServices.Level2Finished({
        id: this.nowPlayer.id,
        score: score
      });
      if (!result.success) {
        alert(result.msg);
      }
    },
    async OnLevel1Finished(score) {
      var result = await DataServices.Level1Finished({
        id: this.nowPlayer.id,
        score: score
      });
      if (!result.success) {
        alert(result.msg);
      }
    },
    async OnCarSelected(index) {
      this.GetPermission();
      this.nowPlayer.carType = index;
      this.isStep1 = false;
      this.isStep2 = true;
      var result = await DataServices.Log({
        deviceId: String(this.nowPlayer.carType)
      });
      if (!result.success) {
        alert(result.msg);
      }
    },
    async OnFinishCountDownEnded() {
      window.location.href = `https://www.facebook.com/dialog/share?app_id=${
        process.env.VUE_APP_FBAPPID
      }&display=popup&href=${process.env.VUE_APP_BASEURL}/share?q=${
        this.nowPlayer.id
      }&redirect_uri=${encodeURIComponent(
        process.env.VUE_APP_BASEURL +
          "/redirect?token=" +
          this.$cookies.get("token")
      )}`;
    },
    async OnCountdownEnded() {
      var result = await DataServices.StartGame({
        id: this.nowPlayer.id
      });
      if (result.success) {
        this.SetLevel("running");
      } else {
        alert(result.msg);
      }
    },
    async OnSelfieUploded(url, sn) {
      this.nowPlayer.pictureUrl = url;
      this.nowPlayer.serialNumber = sn;
      this.isStep2 = false;
      this.isStep3 = true;
      this.$nextTick(async () => {
        await this.$refs.Ready.Countdown();
      });
    },
    GetPermission() {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        DeviceMotionEvent.requestPermission()
          .then(response => {
            if (response == "granted") {
              if (!this.isMotionAdded) {
                window.addEventListener("devicemotion", this.shakeEventHandler);
                this.isMotionAdded = true;
              }
            } else {
              alert("您的裝置不允許使用搖動感應");
            }
          })
          .catch();
      } else {
        if (typeof DeviceMotionEvent !== "undefined") {
          if (!this.isMotionAdded) {
            this.isMotionAdded = true;
            window.addEventListener("devicemotion", this.shakeEventHandler);
          }
        } else {
          alert("您的裝置不支援使用搖動感應");
        }
      }
    },
    shakeEventHandler(event) {
      if (this.isRunning) {
        var THRESHOLD = 100;
        var acceleration = event.accelerationIncludingGravity;
        var curTime = new Date().getTime();
        var diffTime = curTime - this.preTime;
        if (diffTime > 500) {
          this.preTime = curTime;
          this.x = acceleration.x;
          this.y = acceleration.y;
          this.z = acceleration.z;

          var accelerationDiff =
            (Math.abs(
              this.x + this.y + this.z - this.preX - this.preY - this.preZ
            ) /
              diffTime) *
            10000;
          if (accelerationDiff > THRESHOLD) {
            this.$refs.Running.OnShake();
          }
          this.preX = this.x;
          this.preY = this.y;
          this.preZ = this.z;
        }
      }
    }
  }
};
</script>
<style scoped>
.custom-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
  height: 178vw;
}
</style>
